module.exports = __webpack_public_path__ + "img/switch.11a36eec.svg";